
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { singularityStore } from "@/store/store";
import AIJobManager from "./AIJobManager/AIJobManager.vue";
import SingularityDebugPanel from "@/components/Singularity/SingularityDebugPanel.vue";

@Component({
  components: {
    AIJobManager,
    SingularityDebugPanel
  }
})
export default class SingularityRightPanel extends Vue {
  get singularityRightPanelState() {
    return singularityStore.singularityUiState.singularityRightPanel;
  }
}
